module.exports = __webpack_public_path__ + "static/oct_banner-693b23b7d07735d7f0423c8a6c449e5b.png";